<script lang="ts" setup>
import PriceManagement from '@/data-views/tables/pricelist/PriceManagement.vue'
import { loader } from '@/components/loader/loader'

definePage({
  meta: {
    action: 'read',
    subject: 'PriceConfiguration',
    navActiveLink: 'pricelist-pricing',
  },
})

const loading = ref(false)

onMounted(() => {
  loading.value = true
  setTimeout(() => {
    loading.value = false
    loader.stop()
  }, 500)
})
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <PriceManagement v-if="!loading" />
      <div v-else style="min-height: 50vh" />
    </VCol>
  </VRow>
</template>
